import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '@shared/lib/utils';

const Avatar = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-none', className)}
    {...props}
  />
));
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn('aspect-square h-full w-full object-cover object-center', className)}
    {...props}
  />
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Fallback>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      'flex h-full w-full items-center justify-center rounded-none bg-white',
      className
    )}
    {...props}
  />
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

interface AvatarPlaceholderProps {
  className?: string;
}

function AvatarPlaceholder({ className }: AvatarPlaceholderProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      className={cn('h-full w-full', className)}
      role="img"
      aria-hidden="true"
    >
      <rect width="64" height="64" rx="0" fill="hsl(var(--border))" />
      <rect
        x="0.5"
        y="0.5"
        width="63"
        height="63"
        rx="0"
        stroke="hsl(var(--primary))"
        strokeOpacity="0.8"
        fill="none"
      />
      <path
        d="M42.6666 44V41.3333C42.6666 39.9188 42.1047 38.5623 41.1045 37.5621C40.1043 36.5619 38.7477 36 37.3333 36H26.6666C25.2521 36 23.8955 36.5619 22.8953 37.5621C21.8952 38.5623 21.3333 39.9188 21.3333 41.3333V44M37.3333 25.3333C37.3333 28.2789 34.9454 30.6667 31.9999 30.6667C29.0544 30.6667 26.6666 28.2789 26.6666 25.3333C26.6666 22.3878 29.0544 20 31.9999 20C34.9454 20 37.3333 22.3878 37.3333 25.3333Z"
        stroke="hsl(var(--primary))"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export { Avatar, AvatarImage, AvatarFallback, AvatarPlaceholder };
